__turbopack_context__.v({
  "backtotop": "style-module-scss-module__Z5Ybsq__backtotop",
});
